export const colorDictDefault = {
  2: "#eee4da",
  4: "#eee1c9",
  8: "#f3b27a",
  16: "#f69664",
  32: "#f77c5f",
  64: "#f75f3b",
  128: "#edd073",
  256: "#edcc62",
  512: "#edc950",
  1024: "#edc53f",
  2048: "#edc22e",
  super: "#3c3a33",
  light: {
    primary: "rgb(187, 173, 160)",
    secondary: "rgb(119, 110, 101)",
    background: "rgb(250, 248, 239)",
    cell: "rgba(238, 228, 218, 0.4)",
  },
  dark: {
    primary: "rgb(169, 169, 169)",
    secondary: "rgb(102, 102, 102)",
    background: "rgb(47, 44, 44)",
    cell: "rgba(238, 228, 218, 0.5)",
  },
};

export const colorDictBlue = {
  2: "#E8EBEF",
  4: "#D2D7E0",
  8: "#BBC2D0",
  16: "#A4AEC1",
  32: "#8E9AB1",
  64: "#7786A1",
  128: "#607292",
  256: "#4E5B72",
  512: "#44536F",
  1024: "#3A4C6C",
  2048: "#1C3563",
  super: "#3c3a33",
  light: {
    primary: "rgb(187, 173, 160)",
    secondary: "rgb(119, 110, 101)",
    background: "rgb(250, 248, 239)",
    cell: "rgba(238, 228, 218, 0.4)",
  },
  dark: {
    primary: "rgb(169, 169, 169)",
    secondary: "rgb(102, 102, 102)",
    background: "rgb(47, 44, 44)",
    cell: "rgba(238, 228, 218, 0.5)",
  },
};

export const colorDictGreen = {
  2: "#E9EDED",
  4: "#D3DBDA",
  8: "#BECAC8",
  16: "#A8B8B6",
  32: "#92A6A4",
  64: "#7C9491",
  128: "#66827F",
  256: "#51716D",
  512: "#49615E",
  1024: "#405C59",
  2048: "#375753",
  super: "#3c3a33",
  light: {
    primary: "rgb(187, 173, 160)",
    secondary: "rgb(119, 110, 101)",
    background: "rgb(250, 248, 239)",
    cell: "rgba(238, 228, 218, 0.4)",
  },
  dark: {
    primary: "rgb(169, 169, 169)",
    secondary: "rgb(102, 102, 102)",
    background: "rgb(47, 44, 44)",
    cell: "rgba(238, 228, 218, 0.5)",
  },
};

export const textColorDictDefault = {
  small: "#776e65",
  large: "#f9f6f2",
};
